import React from "react";
import { motion } from "framer-motion";

// Totals derived from the two comparison slides — CI context.
// Software piecemeal:    $1,900 – $3,350 /mo (no %)
// AI fixed monthly:      $8,450 – $8,850 /mo (vendor pricing + conservative
//                        staff-time estimates for Asha-only AI)
// AI percent rows:       3.5% Insurance Billing
// Combined fixed:        $10,350 – $12,200 /mo  ≈ $10K–$12K
// Combined percent:      3.5% of collections

const PiecemealTotalSlide = () => {
  return (
    <div className="h-full w-full bg-slate-950 flex items-center justify-center text-white relative overflow-hidden font-sans px-12">
      <div className="absolute inset-0 bg-[linear-gradient(to_right,#ffffff08_1px,transparent_1px),linear-gradient(to_bottom,#ffffff08_1px,transparent_1px)] bg-[size:5rem_5rem]" />

      <motion.p
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
        className="relative z-10 text-[28px] md:text-[36px] lg:text-[44px] font-semibold text-white tracking-tight leading-[1.3] text-center max-w-[1100px]"
      >
        Based on other vendors' published rates, it would cost you{" "}
        <span className="text-amber-300 font-bold whitespace-nowrap">
          $10–12K/mo + 3.5% of collections
        </span>{" "}
        to piece together our offering.
      </motion.p>
    </div>
  );
};

export default PiecemealTotalSlide;
